module.exports = __webpack_public_path__ + "static/media/AssistiveDevicesd23e0e2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/AssistiveDevices.svg
// module id = 1300
// module chunks = 0